import { defineMessages } from 'react-intl';

export default defineMessages({
  isThisClaimRelatedToPersonalAccident: {
    id: 'fastCover.personalAccidentSCTIStep.isThisClaimRelatedToPersonalAccident',
    defaultMessage: 'Is this claim related to Personal Accident?',
  },
  isThisClaimRelatedToLossOfLifeCausedByAnInjury: {
    id: 'fastCover.personalAccidentSCTIStep.isThisClaimRelatedToLossOfLifeCausedByAnInjury',
    defaultMessage: 'Is this claim related to loss of life caused by an injury?',
  },
  didTheInjuryLeaveYouPermanentlyDisabled: {
    id: 'fastCover.personalAccidentSCTIStep.didTheInjuryLeaveYouPermanentlyDisabled',
    defaultMessage: 'Did the injury leave you permanently disabled?',
  },
  didTheInjuryResultInYourInabilityToReturnToWork: {
    id: 'fastCover.personalAccidentSCTIStep.didTheInjuryResultInYourInabilityToReturnToWork',
    defaultMessage: 'Did the injury result in your inability to return to work?',
  },
  dateYouWereOriginallyDueBackAtWork: {
    id: 'fastCover.personalAccidentSCTIStep.dateYouWereOriginallyDueBackAtWork',
    defaultMessage: 'Date you were originally due back at work',
  },

  expenseFor: {
    id: 'fastCover.personalAccidentSCTIStep.expenseFor',
    defaultMessage: 'Expense For',
  },
  descriptionOfItem: {
    id: 'fastCover.personalAccidentSCTIStep.descriptionOfItem',
    defaultMessage: 'Description of item',
  },
  dateOfExpenses: {
    id: 'fastCover.personalAccidentSCTIStep.dateOfExpenses',
    defaultMessage: 'Date Of Expenses',
  },
  amountClaimed: {
    id: 'fastCover.personalAccidentSCTIStep.amountClaimed',
    defaultMessage: 'Amount Claimed',
  },
  currency: {
    id: 'fastCover.personalAccidentSCTIStep.currency',
    defaultMessage: 'Currency',
  },

  dentalExpenses: {
    id: 'fastCover.personalAccidentSCTIStep.dentalExpenses',
    defaultMessage: 'Dental Expenses',
  },
  funeralExpenses: {
    id: 'fastCover.personalAccidentSCTIStep.funeralExpenses',
    defaultMessage: 'Funeral Expenses',
  },
  isRequired: {
    id: 'fastCover.personalAccidentSCTIStep.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  addItem: {
    id: 'fastCover.personalAccidentSCTIStep.addItem',
    defaultMessage: 'Add Expense',
  },
  itemWithIdx: {
    id: 'fastCover.personalAccidentSCTIStep.itemWithIdx',
    defaultMessage: 'Item(s) {idx}',
  },
  yes: {
    id: 'fastCover.personalAccidentSCTIStep.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.personalAccidentSCTIStep.no',
    defaultMessage: 'No',
  },
  selectInsuredForExpense: {
    id: 'fastCover.personalAccidentSCTIStep.selectInsuredForExpense',
    defaultMessage: 'Select the Insured(s) for the expense',
  },
  amountClaimExceedsMaximumDigits: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.amountClaimExceedsMaximumDigits',
    defaultMessage: 'Amount Claimed exceeds the maximum allowable digits. Please enter a valid claim amount.',
  },
  descriptionMaxLength: {
    id: 'fastCover.personalAccidentSCTIStep.descriptionMaxLength',
    defaultMessage: 'Please enter maximum of 150 characters',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.PersonalAccident/messages.js